import {
  Button,
  Chip,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Textarea,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import dict from "../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import {ServiceContext} from "../../context/service";
import {PersianNumberInput} from "../system/persianNumberInput";
import {submitAgentServiceSideCost, updateAgentServiceSideCost} from "../../services/service/side_cost";
import FileInput from "../system/fileInput";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function AgentServiceSideCostForm() {

  const {
    service,
    sideCost,
    setSideCost,
    setSideCosts,
    modalOpen,
    setModalOpen,
    setLastDataRefresh,
    setStep,
    setTotalSideCosts,
  } = useContext(ServiceContext);

  const handleOpen = () => setModalOpen(!modalOpen);


  const [branchDocumentId, setBranchDocumentId] = useState(null)

  const [cost, setCost] = useState(sideCost?.cost ?? 0)
  const [description, setDescription] = useState(document?.description ?? "")
  const [status, setStatus] = useState("")
  const [disable, setDisable] = useState(service.status === "settled")


  useEffect(() => {
    setSideCost(sideCost => ({
      ...sideCost,
      cost: cost,
    }))
  }, [sideCost]);

  const save = async () => {
    const data = sideCost;

    data.service_id = service.id

    let result;

    if (!data.id) {
      result = await submitAgentServiceSideCost(data);
    } else {
      result = await updateAgentServiceSideCost(data)
    }

    if (result.status === 201 || result.status === 202) {
      const {service_side_costs} = result.data;
      setSideCosts(service_side_costs);
      let total_side_costs = 0;
      if (service_side_costs && Array.isArray(service_side_costs)) {
        total_side_costs = service_side_costs.reduce((sum, sideCost) => sum + (sideCost.cost || 0), 0);
      }

      setTotalSideCosts(total_side_costs)
      setStep("check")

      setSideCost(null)
    }
  };

  useEffect(() => {
    if (status === "upload") {
      setStatus("rejected")
    }
  }, [status]);

  return (
    <>
      <Dialog open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          {document &&
            <Typography>
              {service.person_name + " " + service.person_family + " - " + service.field_title + " " + service.branch_title}
            </Typography>
          }
          {!document &&
            <Typography>ثبت هزینه جانبی جدید</Typography>
          }
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          {!sideCost?.id ?
            <div className="mb-4">
              <Input variant="standard"
                     value={sideCost?.title}
                     label={Dict('title')}
                     placeholder={Dict('title')}
                     onChange={(e) => {
                       setSideCost(sideCost => ({
                         ...sideCost,
                         title: e.target.value,
                       }))
                     }}
              />
            </div>
            :
            <div className="flex flex-row mb-4">
              <Typography className="ml-4">
                {`${dict("title")}:`}
              </Typography>
              <Typography color="blue-gray">
                {`${sideCost?.title}`}
              </Typography>
            </div>
          }

          {!sideCost?.id ?
            <div className="mb-4">
              <Textarea variant="standard"
                        value={sideCost?.description}
                        label={Dict('description')}
                        placeholder={Dict('description')}
                        onChange={(e) => {
                          setSideCost(sideCost => ({
                            ...sideCost,
                            description: e.target.value,
                          }))
                        }}
              />
            </div>
            :
            <div className="flex flex-row mb-4">
              <Typography className="ml-4">
                {`${dict("description")}:`}
              </Typography>
              <Typography color="blue-gray">
                {`${sideCost?.description}`}
              </Typography>
            </div>
          }

          {!sideCost?.id ?
            <div className="flex flex-row mb-4">
              <PersianNumberInput value={cost} label={Dict("side_cost")} setValue={setCost}
                                  extension="ریال"/>
            </div>
            :
            <div className="flex flex-row mb-4">
              <Typography className="ml-4">
                {`${dict("side_cost")}:`}
              </Typography>
              <Typography color="blue-gray">
                {`${persianNumberFormat(sideCost?.cost, true)} ریال`}
              </Typography>
            </div>
          }

          {service.status !== "new" && service.side_cost_payer === "agent" &&
            <div className="flex flex-col w-full mb-4">
              <FileInput
                label={Dict('upload_receipt_file')}
                fileCode={sideCost?.file}
                onChange={(e) => {
                  setSideCost(sideCost => ({
                    ...sideCost,
                    file: e.target.files[0],
                  }))
                }}/>
              {/*<Validator state={file} rules="required"/>*/}
            </div>
          }

          {sideCost?.status?.length > 0 ??
            <div className="flex flex-row">
              <Typography color="blue-gray" className="font-medium ml-2">
                وضعیت مدرک:
              </Typography>
              <Chip className="textRight" variant="ghost"
                    value={Dict(sideCost?.status)}
                    color={sideCost?.status === "agent_payed" || sideCost?.status === "person_payed" ? "cyan" : sideCost?.status === "new" ? "amber" : sideCost?.status === "settled" ? "teal" : "red"}/>
            </div>
          }

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={() => {
            // handleOpen();
            setStep("check")
          }}>
            <span>انصراف</span>
          </Button>
          {!disable &&
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>ذخیره</span>
            </Button>
          }
        </DialogFooter>
      </Dialog>
    </>
  );
}